import { APICore } from "./apiCore";

const api = new APICore();

function fetchProduct(params: { page: string, limit: string, sortBy: string, sort: string, searchBy?: string }) {
  const baseUrl = `/product?page=${params.page}&limit=${params.limit}&sortBy=${params.sortBy}&sort=${params.sort}&searchBy=${params.searchBy ? params.searchBy : ''}`;
  return api.get(`${baseUrl}`, "");
}

function fetchSingleProduct(id: any) {
  const baseUrl = `/product/${id}`;
  return api.get(`${baseUrl}`, id);
}

function createProduct(body: any) {
  const baseUrl = "/product";
  return api.create(`${baseUrl}`, body);
}

function updateProduct(body: any) {
  const baseUrl = `/product/${body.id}`;
  return api.update(`${baseUrl}`, body);
}

function getProductSkuWise(params: { limit: string, filterBy?: any, filter?: any }) {
  const baseUrl = `/product/sku/wise?limit=${params.limit}&filterBy=${params.filterBy}&filter=${params.filter}`;
  return api.get(`${baseUrl}`, "");
}

export { fetchProduct, fetchSingleProduct, createProduct, updateProduct, getProductSkuWise };
